export default __webpack_public_path__ + "static/media/intersection.341e37f3.gif";